import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

type AttachmentTypeString = 'picture' | 'join' | 'diary';

interface AttachmentType {
  id: string;
  name: string;
  type?: AttachmentTypeString;
  unique?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ApiTravelHelperService {
  attachmentTypes: AttachmentType[] = [
    {
      id: 'background',
      name: 'Photo de couverture (.jpg)',
      type: 'picture',
      unique: true,
    },
    {
      id: 'detail',
      name: 'Affiche CSE et vos propres conditions tarifaires auprès des participants (.pdf)\n',
      type: 'join',
      unique: true,
    },
    {
      id: 'info',
      name: 'Informations pratiques',
      type: 'join',
    },
    { id: 'program', name: 'Programmes', type: 'diary' },
    { id: 'map', name: 'Plans', type: 'diary' },
    { id: 'voucher', name: 'Vouchers', type: 'diary' },
    { id: 'rooming', name: 'Rooming', type: 'diary' },
    { id: 'other', name: 'Autres', type: 'diary' },
  ];

  status = [
    { id: 'opened', name: 'Ouvert', color: 'success' },
    { id: 'closed', name: 'Fermé', color: 'warn' },
  ];

  constructor(private _apiSrv: ApiService) {}

  getAttachmentTypes(key: AttachmentTypeString) {
    return this.attachmentTypes.filter((t) => t.type === key);
  }

  getAttachmentWithTypes(travel: any, key: AttachmentTypeString) {
    return travel?.attachments?.filter((t: any) => t.type === key);
  }

  getHasAttachmentWithType(travel: any, key: AttachmentTypeString) {
    return travel?.attachments?.filter((t: any) => t.type === key).length > 0;
  }

  getStatusName(travel: any) {
    const status = this.status.find((item) => item.id == travel?.status);
    return status?.name || 'Inconnu';
  }

  getStatusColor(travel: any) {
    const status = this.status.find((item) => item.id == travel?.status);
    return status?.color || 'accent';
  }

  getImportMembersModelUrl(travel: any, format = 'csv') {
    return (
      this._apiSrv.options.apiUrl +
      '/travel/import-members-model/id/' +
      travel.id +
      '/format/' +
      format
    );
  }
}
